export const packageInfo = require('../package.json');

export function defaultHeaders() {
  let headers = new Headers();
  const token = localStorage.getItem('token');
  if (token !== null) {
    headers.append('Authorization', `Bearer ${token}`);
  }

  return headers;
}

export function isGuestUser() {
  let userString = localStorage.getItem('user');
  if (userString !== null) {
    let user = JSON.parse(userString);
    return user.role === 'guest';
  }
  return true;
}

export function isAdminUser() {
  let userString = localStorage.getItem('user');
  if(userString !== null) {
    return JSON.parse(userString).role === "admin";
  }
  return false;
}

export function isCommercialUser() {
  let userString = localStorage.getItem('user');
  if (userString !== null) {
    let user = JSON.parse(userString);
    return user.role === 'commercial';
  }
  return false;
}

export function isNonCommercialUser() {
  let userString = localStorage.getItem('user');
  if (userString !== null) {
    let user = JSON.parse(userString);
    return user.role === 'none-commercial';
  }
  return false;
}

export function loginGuest(afterLoginAction) {
  fetch("/api/login", {
    method: 'POST',
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: "username=guest",
  })
    .then(resp => resp.json())
    .then(json => {
      if (json.loggedIn) {
        localStorage.setItem('user', JSON.stringify(json));
        localStorage.setItem('token', json.token);
        if (afterLoginAction !== undefined && afterLoginAction !== null) {
          afterLoginAction();
        }
      }
    });
}

export function translateRequiredFields(string){

  switch (string) {

    case "categories":
      return " mind. eine Kategorie ";

    case "name":
      return "Was Sie anbieten ";

    case "references":
      return " Ihre Spezialisierungsbereiche ";

    case "dl_agreement":
      return " Einverständnis-Erklärung";

    case "description":
      return " der Zweck Ihres Produkts";

    case "price":
      return " Preis ";

    case "sw_agreement_1":
      return "Erklärung zum Besitz 1";

    case "sw_agreement_2":
      return "Erklärung zum Besitz 2";

    case "sw_agreement_3":
      return "Erklärung zum Besitz 3";

    case "sw_agreement_4":
      return "Erklärung zum Besitz 4";

    case "sw_agreement_5":
      return "Erklärung zum Besitz 5";

    case "sw_agreement_6":
      return "Erklärung zum Besitz 6";

    case "agb_agreement":
      return "Vereinbarung";

    default:
      return string;

  }
}

export function logoutAndRedirect (messageFunction, history) {
  loginGuest( function() {
    const pathname = window.location.pathname;
    if(pathname !== '/') {
      messageFunction("Ihre Sitzung ist abgelaufen. Sie werden zur Startseite umgeleitet.");
    } else {
    }
    if(pathname !== '/') {
      setTimeout( () => history.push('/'), 3000);
    } else {
      setTimeout( () => history.replace('/'), 500);
    }
  });
  return true;
}

export function redirectToSearch(searchString, history) {
  localStorage.setItem('ayacandas_filter', '');
  localStorage.setItem('ayacandas_search', searchString);
  setTimeout( () => history.push('/search'), 500 );
  return true;
}

export function translateTypeIntoEnglish(type) {
  switch (type) {
    case "Dokument":
      return 'document';
    case "Software":
      return 'software';
    case "Dienstleistung":
      return "service";
    case "Ausschreibung":
      return "tender";
    case "Gebrauchtsoftware":
      return "used_software";
    case "Software F+L":
      return "researchsoftware";
    case "Dienstleistung Alt":
      return "service old";
    case "Software Alt":
      return "software old";
    case "Hardware und sonstige Angebote":
      return "other";
    default:
      return "unknown product type";
  }
}

export function handleErrors(response) {
  if (!response.ok)
    throw Error(response.statusText);
  return response;
}



// WEBPACK FOOTER //
// ./src/util.js